import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceGuard {

  constructor(private configurationService: ConfigurationService, private router: Router) {}

  canActivate() {

    if (!this.configurationService.home.maintenanceMode) {
      return true;
    } else {
      this.router.navigate(['/maintenance']);
      return false;
    }
  }

}
